<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Gerencia as configurações do Sistema.</span>
                <br />
                <span class="navigation">Configurações > Sistema</span>
              </h4>
            </div>
          </div>
        </div>

        <form name="form" @submit.prevent="onSubmit">
          <TabView >
            <TabPanel header="Campos">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="nome">URL Sistema:</label>
                    <span class="p-fluid">
                      <InputText type="text" id="urlSistema" v-model="configuracao.urlSistema" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="nome">Conta de E-Mail Cliente:</label>
                    <span class="p-fluid">
                      <InputText type="text" :disabled="this.camposAtivos === 'N'" id="contaEmail" v-model="configuracao.contaEmail" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="nome">Permitir Tomador Não Informado?</label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolTomadorNaoInformado" v-model="selectedTomadorNaoInformado" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="nome">Dias Emissão Retroativa de Notas Fiscais:</label>
                    <span class="p-fluid">
                      <InputText v-model="configuracao.nfDiasEmissaoRetroativa" type="number"  />
                    </span>
                  </div>
                  <div class="col-md-3 mb-2">
                    <label for="nome">Dias Emissão Retroativa de Notas Fiscais RPS:</label>
                    <span class="p-fluid">
                      <InputText v-model="configuracao.nfDiasEmissaoRetroativaRps" type="number"  />
                    </span>
                  </div>
                  <div class="col-md-3 mb-2">
                    <label for="nome">Dias Emissão Retroativa de Notas Fiscais Avulsas:</label>
                    <span class="p-fluid">
                      <InputText v-model="configuracao.nfDiasEmissaoRetroativaNfAvulsa" type="number"  />
                    </span>
                  </div>
                  <div class="col-md-3 mb-2">
                    <label for="nome">Dias Emissão Retroativa de DAPS:</label>
                    <span class="p-fluid">
                      <InputText v-model="configuracao.nfDiasEmissaoRetroativaDaps" type="number"  />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="nome">Prazo Dias Cancelamento Notas Fiscais:
                      <Button 
                        class="pi pi-exclamation-circle" 
                        v-tooltip.right="tooltipText"
                        @click="openTextCancNfsConfig()"
                        style="margin-left: 5px; cursor: pointer;"
                      ></Button>
                    </label>
                    <span class="p-fluid">
                      <InputText v-model="configuracao.nfPrazoDiasCancelamento" type="number"  />
                    </span>
                  </div>
                  <div class="col-md-3 mb-2">
                    <label for="nome">Prazo Dias Cancelamento Notas Fiscais (Optante Simples Nacional):
                      <Button 
                        class="pi pi-exclamation-circle" 
                        v-tooltip.right="tooltipText"
                        @click="openTextCancNfsOptanteConfig()"
                        style="margin-left: 5px; cursor: pointer;"
                      ></Button>
                    </label>
                    <span class="p-fluid">
                      <InputText v-model="configuracao.nfPrazoDiasCancelamentoSimples" type="number"  />
                    </span>
                  </div>
                  <div class="col-md-3 mb-2">
                    <label for="nome">Prazo Dias Substituição Notas Fiscais:
                      <Button 
                        class="pi pi-exclamation-circle" 
                        v-tooltip.right="tooltipText"
                        @click="openTextSubsNfsConfig()"
                        style="margin-left: 5px; cursor: pointer;"
                      ></Button>
                    </label>
                    <span class="p-fluid">
                      <InputText v-model="configuracao.nfPrazoDiasSubstituicao" type="number"  />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="nome">Prazo Dias Cancelamento DAPS/Nota Tomador:</label>
                    <span class="p-fluid">
                      <InputText v-model="configuracao.nfPrazoDiasCancelamentoDaps" type="number"  />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="nome">Cancelar Nota Fiscal por Data de Emissão?</label>
                    <span class="p-fluid">
                      <Dropdown  id="selectedCancNfseDataEmissao" v-model="selectedCancNfseDataEmissao" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="nome">Prazo Dias Emitir Carta de Correção:</label>
                    <span class="p-fluid">
                      <InputText v-model="configuracao.prazoDiasCartaCorrecao" type="number"  />
                    </span>
                  </div>
                  <div class="col-md-3 mb-2">
                    <label for="nome">Prazo Dias Cancelar Carta de Correção:</label>
                    <span class="p-fluid">
                      <InputText v-model="configuracao.prazoDiasCancelamentoCarta" type="number"  />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="nome">Permitir Alíquota Zero Autonomo?</label>
                    <span class="p-fluid">
                      <Dropdown  id="selectedAutonomoAliqZero" v-model="selectedAutonomoAliqZero" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="nome">Permitir Alíquota Zero Simples Nacional?</label>
                    <span class="p-fluid">
                      <Dropdown  id="selectedSimplesAliqZero" v-model="selectedSimplesAliqZero" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="selectedSublimiteAlterarAliquota">Alterar Alíquota Sublimite Simples Nacional?
                      <Button 
                      class="pi pi-exclamation-circle" 
                      v-tooltip.right="tooltipText"
                      @click="openTextConfigAlqSubNfse()"
                      style="margin-left: 5px; cursor: pointer;"
                    ></Button>
                    </label>
                    <span class="p-fluid">
                      <Dropdown  id="selectedSublimiteAlterarAliquota" v-model="selectedSublimiteAlterarAliquota" :options="opcoesAlterarAlqNotas"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="nome">Permitir Retenção na Fonte Pessoa Física?</label>
                    <span class="p-fluid">
                      <Dropdown  id="selectedRetencaoPessoaFisica" v-model="selectedRetencaoPessoaFisica" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="nome">Tipo Geração de DAM Automática?
                      <Button 
                      class="pi pi-exclamation-circle" 
                      v-tooltip.right="tooltipText"
                      @click="openTextFechamentoAutomatico()"
                      style="margin-left: 5px; cursor: pointer;"
                    ></Button>
                    </label>
                    <span class="p-fluid">
                      <Dropdown  id="tipoGeracaoDamAutomatica" v-model="selectedGeracaoDamAutomatica"
                        :options="opcoesGeracaoAutomatica" optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="nome">Realizar Fechamento Automático?</label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolFechamentoAutomatico" v-model="selectedFechamentoAutomatico" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="nome">Quantidade de Notas Avulsas por Mês:</label>
                    <span class="p-fluid">
                      <InputText v-model="configuracao.nfQtdeNotasAvulsasMes" type="number"  />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="nome">Quantidade de Notas Avulsas por Ano:</label>
                    <span class="p-fluid">
                      <InputText v-model="configuracao.nfQtdeNotasAvulsasAno" type="number"  />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="nome">Atualizar Endereços de Pessoa quando credenciamento Eventual?</label>
                    <span class="p-fluid">
                      <Dropdown  id="selectedAtualizaEnderecoPessoa" v-model="selectedAtualizaEnderecoPessoa"
                        :options="opcoes" optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="nome">Permitir Retenção para Tomador Eventual?</label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolTomadorRetTomadorEventual" v-model="selectedRetTomadorEventual" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="selectedCartaCorrecao">Carta de Correção?</label>
                    <span class="p-fluid">
                      <Dropdown  id="selectedCartaCorrecao" v-model="selectedCartaCorrecao" :options="opcoesCarta"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="selectedExibirCampoObservacao">Exibir Campo Observação Emissão Nfse?</label>
                    <span class="p-fluid">
                      <Dropdown  id="selectedExibirCampoObservacao" v-model="selectedExibirCampoObservacao"
                        :options="opcoes" optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="idBolAliquotaSimplesRbt12">Simples Nacional (Utilizar Alíquota com base na receita bruta total do RBT12)?</label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolAliquotaSimplesRbt12" v-model="selectedAliquotaSimplesRbt12" :options="opcoesRbt12"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="valorLimiteDamNfa">Valor Limite para geração de DAM Nota Avulsa?</label>
                    <span class="p-fluid">
                      <money id="deducao" name="valorLimiteDamNfa" v-model="configuracao.valorLimiteDamNfa" v-bind="money"
                        class="p-inputtext input-right"></money>
                    </span>
                  </div>
                  <div class="col-md-3 mb-2">
                    <label for="valorLimiteDamNfa">Percentual Limite Abatimento de Crédito?</label>
                    <span class="p-fluid">
                      <money id="percLimiteCredito" name="percentualLimiteAbatimentoCredito" v-model="configuracao.percentualLimiteAbatimentoCredito" v-bind="percent"
                        class="p-inputtext input-right"></money>
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="idBolBloquearTomadorInativo">Bloquear emissão nfse tomador de serviços inativo?
                      <Button 
                        class="pi pi-exclamation-circle" 
                        v-tooltip.right="tooltipText"
                        @click="openTextBloquearTomador()"
                        style="margin-left: 5px; cursor: pointer;"
                      ></Button>
                    </label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolBloquearTomadorInativo" v-model="selectedBloqTomadorInativo" :options="opcoesBloquearTomadorInativo"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="idBolNtAvulsaSemPgto">Permitir Impressão Notas Avulsas sem Pagamento?
                      <Button 
                        class="pi pi-exclamation-circle" 
                        v-tooltip.right="tooltipText"
                        @click="openTextVisuDam()"
                        style="margin-left: 5px; cursor: pointer;"
                      ></Button>
                    </label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolNtAvulsaSemPgto" v-model="selectedNtAvulsaSemPgto" :options="opcoesNtAvulsaSemPgto"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="idBolDesabilitarCredencAvulsa">Desabilitar Credenciamento Nota Avulsa?</label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolDesabilitarCredencAvulsa" v-model="selectedDesabCredencAvulsa" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="idBolCalculoImpostosFederais">Habilitar Cálculo de Impostos Federais na Nota Avulsa?</label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolCalculoImpostosFederais" v-model="selectedCalculoImpostosFederais" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="idBolSelTomadorDiferente">Bloquear Substituição Nota Tomador Diferente?</label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolSelTomadorDiferente" v-model="selectedDesabTomadorDiferente" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="idBolNtAvulsaSemPgto">Retificar Declarações Por Análise?</label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolNtAvulsaSemPgto" v-model="selectedDeclaracaoAnalise" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row" >
                  <div class="col-md-3 mb-2">
                    <label for="idBolAceiteTomador">Habilitar Aceite de Notas Substituição Tributária? Quando habilitado o tomador podera realizar a retenção indevida de uma nota fiscal (o tomador tera acesso a mudar as notas retidas para não reitdo, passando o ISS para o prestador)!</label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolAceiteTomador" v-model="selectedAceiteTomador" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row" v-if="false"><!-- desabilitado pois a rotina esta com problemas -->
                  <div class="col-md-3 mb-2">
                    <label for="idBolRecusaDeclaracao">Habilitar Recusa de Declarações?</label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolRecusaDeclaracao" v-model="selectedRecusaDeclaracao" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="idBolDamDecSimplificada">Habilitar Geração de ISS (DAM) Declaração Simplificada Simples Nacional?</label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolDamDecSimplificada" v-model="selectedDesabDamSimplificada" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="idBolAnaliseCreden">Habilitar Análise de Credenciamento para Fora Município?</label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolAnaliseCreden" v-model="selectedAnaliseCredenFora" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                  <div class="col-md-3 mb-2">
                    <label for="idBolRegistrarCredEventual">Registrar Credenciamentos do Eventual no GPI? Quando Sim, o GPI registrará tambem na tela de Consulta Deferimento os registros automáticos do Eventual gerados pelo Nfse.</label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolRegistrarCredEventual" v-model="selectedRegistraCredEventual" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>  
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="nome">Informar Intermediário na Emissão da NFSe?</label>
                    <span class="p-fluid">
                      <Dropdown id="idIntermediario" v-model="selectedIntermediario" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="nome">Habilitar Aceite de Cancelamento de Nota Fiscal pelo Tomador?</label>
                    <span class="p-fluid">
                      <Dropdown id="idAceiteCancelamento" v-model="selectedAceiteCancelamento" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="nome">Dias Para Bloqueio Pagamento de DAM de ISS Após o Vencimento: 
                      <Button 
                        class="pi pi-exclamation-circle" 
                        v-tooltip.right="tooltipText"
                        @click="openTextDamConfig()"
                        style="margin-left: 5px; cursor: pointer;"
                      ></Button>
                    </label>
                    <span class="p-fluid">
                      <InputText v-model="configuracao.nfDiasTravaPagamentoBoleto" type="number"  />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="nome">Habilitar Manisfestação de NFSe pelo Tomador?</label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolManifestacao" v-model="selectedManifestacao" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="nome">Manifestação - Prazo Dias:</label>
                    <span class="p-fluid">
                      <InputText v-model="configuracao.nfManifestacaoPrazoDias" type="number"  />
                    </span>
                  </div>
                  <div class="col-md-4 mb-2">
                    <label for="nome">Manifestação - Valor Mínimo:</label>
                    <span class="p-fluid">
                      <money id="manifestacaoValorMinimo" name="nfManifestacaoValorMinimo" v-model="configuracao.nfManifestacaoValorMinimo" v-bind="money"
                        class="p-inputtext input-right"></money>
                    </span>
                  </div>
                  <div class="col-md-4 mb-2">
                    <label for="nome">Manifestação - Tipo Pessoa:</label>
                    <span class="p-fluid">
                      <Dropdown id="idTipoPessoa" v-model="selectedTipoPessoa" :options="opcoesTipoPessoa"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="dataBloqueioMei">Data Bloqueio emissão MEI:</label><!-- - (Bloquear emissão quando contribuinte enquadrado como MEI )-->
                    <span class="p-fluid">
                      <Calendar id="dataBloqueioMei" name="dataBloqueioMei" v-model="configuracao.dataBloqueioEmissaoMei"
                        :showIcon="true" dateFormat="dd/mm/yy"  v-maska="'##/##/####'"/>
                    </span>
                  </div>
                  <div class="col-md-6 mb-2">
                    <label for="msgBloqueioMei">Mensagem Bloqueio emissão MEI:</label>
                    <span class="p-fluid">
                      <textarea id="msgBloqueioMei" name="msgBloqueioMei" v-model="configuracao.msgBloquearEmissaoMei"
                        rows="5" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="idBolExibirDetalhamentoDam">Exibir Detalhamento do Prestador no DAM de Substituição, quando o dam conter apenas uma nota/daps?</label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolExibirDetalhamentoDam" v-model="selectedDetalhamentoDam" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="idBolInscricaoCredenAutomatica">Habilitar Inscrição Municipal Credenciamento Automática?</label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolInscricaoCredenAutomatica" v-model="selectInscricaoCredenAutomatica" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="idBolInscricaoCredenAutomatica">Permitir Retenção de Notas Fiscais quando Contribuinte configurado como Substituto Tributário no GPI?</label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolSubsTributarioGpi" v-model="selectIdBolSubsTributarioGpi" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="idBolInscricaoCredenAutomatica">Permitir Edição de E-mail ao Vincular Responsáveis?</label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolEditarEmailUsuarioRes" v-model="selectIdBolEditarEmailUsuarioRes" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="idBolValidarIdRps">Deseja que a rotina de recebimento e conversão de RPS em NFSe valide se o campo ID da RPS já foi enviado anteriomente (ID da RPS é o Código Verificação da NFSe)?</label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolValidarIdRps" v-model="selectIdBolValidarIdRps" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="idBolCredenAutoMunic">Habilitar Aceite Automático Credenciamento Pertencente ao Município?</label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolCredenAutoMunic" v-model="selectIdBolCredenAutoMunic" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="idBolCompensaIssDaps">Habilitar Compensação Valor ISS DAPS?</label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolCompensaIssDaps" v-model="selectedIdBolCompensaIssDaps" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="idBolRetDecFechaAuto">Permitir Retificar Declarações com Fechamento Automático?</label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolRetDecFechaAuto" v-model="selectedIdBolRetDecFechaAuto" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="idBolValidaValorNotaSubs">Permitir Validar Valor Nota Fiscal Substituição?</label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolValidaValorNotaSubs" v-model="selectedIdBolValidaValorNotaSubs" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgBloqueioMei">Mensagem Contribuintes DTEL, quando configurada é exibida para contribuintes que ainda não estão credenciados no DTEL.</label>
                    <span class="p-fluid">
                      <textarea id="msgCredenciamentoDtel" name="msgCredenciamentoDtel" v-model="configuracao.msgCredenciamentoDtel"
                        rows="5" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgTermoCancNfsPadrao">Mensagem Padrão Termo de Cancelamento de Notas Fiscais Fora do Prazo.
                      <Button 
                        class="pi pi-exclamation-circle" 
                        v-tooltip.right="tooltipText"
                        @click="openTextTermoCancNfs()"
                        style="margin-left: 5px; cursor: pointer;"
                      ></Button>
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <textarea disabled v-model="msgTermoCancNfsPadrao" class="mensagem-padrao" rows="5" />
                    <label for="msgTermoCancNfsPadrao">Texto Adicional para o Termo de Cancelamento de Nota Fiscal:
                      <Button 
                      class="pi pi-exclamation-circle" 
                      v-tooltip.right="tooltipText"
                      @click="openTextAdicTermoCancNfs()"
                      style="margin-left: 5px; cursor: pointer;"
                    ></Button>
                    </label>
                    <textarea id="msgTermoCancNfse" name="msgTermoCancNfse" v-model="configuracao.msgTermoCancNfse"
                      rows="5" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgContatoLogin">Mensagem Contato Login:
                      <Button 
                        class="pi pi-exclamation-circle" 
                        v-tooltip.right="tooltipText"
                        @click="openMsgContatoLogin()"
                        style="margin-left: 5px; cursor: pointer;"
                      ></Button>
                    </label>
                    <span class="p-fluid">
                      <textarea id="msgContatoLogin" name="msgContatoLogin" v-model="configuracao.msgContatoLogin"
                        rows="5" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgRegimeTribuNfse">Mensagem Preenchimento Regime Tributário Emissão NFS-E:
                    </label>
                    <span class="p-fluid">
                      <textarea id="msgAvisoRegimeTribuNfse" name="msgAvisoRegimeTribuNfse" v-model="configuracao.msgAvisoRegimeTribuNfse"
                        rows="5" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="linkTutoriais">URL Tutoriais, irá habilitar o link abaixo na tela de login:</label>
                    <span class="p-fluid">
                      <InputText type="text" id="urlSistema" v-model="configuracao.linkTutoriais" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="linkTutoriais">URL Manual Administrador:</label>
                    <span class="p-fluid">
                      <InputText type="text" id="urlManualAdmin" v-model="configuracao.linkManualAdmin" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="linkTutoriais">URL Manual Contribuinte:</label>
                    <span class="p-fluid">
                      <InputText type="text" id="urlManualContribuinte" v-model="configuracao.linkManualContribuinte" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="idBolProducaoRestrita">Habilitar Menus de Testes Produção Restrita Nota Nacional?</label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolProducaoRestrita" v-model="selectIdBolProducaoRestrita" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="urlApiNotaNacional">URL Api Nota Nacional:</label>
                    <span class="p-fluid">
                      <InputText type="text" id="urlApiNotaNacional" v-model="configuracao.urlTutoriaisNotaNacional" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="codigosErroNotaNacional">Códigos de Erro Ignorados do Nota Nacional (separar por vígula). A NFSe será transcrita com a situação "Decisão Judicial":</label>
                    <span class="p-fluid">
                      <InputText type="text" id="codigosErroNotaNacional" v-model="configuracao.codigosErroNotaNacional" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="nome">Tornar obrigatório o preenchimento do serviço NBS na emissão da NFS-e?</label>
                    <span class="p-fluid">
                      <Dropdown  id="selectedValidaNovosImpostosNacionais" v-model="selectedValidaNovosImpostosNacionais" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="dataBloqueioNfse">Data Bloqueio emissão NFs-e(utilizar somente se a emissão passsara a ser realizada no nota nacional):</label>
                    <span class="p-fluid">
                      <div class="calendar-wrapper">
                        <Calendar id="dataBloqueioNfse" name="dataBloqueioNfse" v-model="configuracao.dataBloqueioEmissaoNfse" :showIcon="true" dateFormat="dd/mm/yy"  v-maska="'##/##/####'" />
                        <i v-if="configuracao.dataBloqueioEmissaoNfse" class="pi pi-times clear-icon" @click="configuracao.dataBloqueioEmissaoNfse = null" title="Limpar data"></i>
                      </div>
                    </span>
                  </div>
                  <div class="col-md-6 mb-2">
                    <label for="msgBloqueioNfse">Mensagem Bloqueio emissão NFs-e(sera ativado somente se a data acima estiver preenchida):</label>
                    <span class="p-fluid">
                      <textarea id="msgBloqueioNfse" name="msgBloqueioNfse" v-model="configuracao.msgBloquearEmissaoNfse" rows="5" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="idBolHabilitarDpsProducao">Habilitar Modelo de Emissão por DPS?</label>
                    <span class="p-fluid">
                      <Dropdown  id="idBolHabilitarDpsProducao" v-model="selectIdBolHabilitarDpsProducao" :options="opcoes"
                        optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-2">
                    <label for="versaoImpressaoDanfseNacional">Versão Impressão DANFSe Nacional:</label>
                    <span class="p-fluid">
                      <Dropdown id="versaoImpressaoDanfseNacional" v-model="selectedVersaoDanfseNacional" :options="opcoesVersaoNacional" optionLabel="name" placeholder="Selecione uma opção" />
                    </span>
                  </div>
                </div>
                
              </div>
            </TabPanel>
            <TabPanel header="Mensagens E-Mail">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgEmailEmissaoNota">Mensagem E-Mail Emissão Nota:</label>
                    <textarea id="msgEmailEmissaoNota" name="msgEmailEmissaoNota"
                      v-model="configuracao.msgEmailEmissaoNota" rows="5" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgEmailCancelamentoNota">Mensagem E-Mail Cancelamento Nota:</label>
                    <span class="p-fluid">
                      <textarea id="msgEmailCancelamentoNota" name="msgEmailCancelamentoNota"
                        v-model="configuracao.msgEmailCancelamentoNota" rows="5" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgEmailEmissaoDaps">Mensagem E-Mail Emissão DAPS:</label>
                    <span class="p-fluid">
                      <textarea id="msgEmailEmissaoDaps" name="msgEmailEmissaoDaps"
                        v-model="configuracao.msgEmailEmissaoDaps" rows="5" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgEmailNovoUsuario">Mensagem E-Mail Novo Usuário:</label>
                    <span class="p-fluid">
                      <textarea id="msgEmailNovoUsuario" name="msgEmailNovoUsuario"
                        v-model="configuracao.msgEmailNovoUsuario" rows="5" />
                    </span>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="Mensagens Sistema">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgCartaCorrecao">Mensagem Carta de Correção:</label>
                    <textarea id="msgCartaCorrecao" name="msgCartaCorrecao"
                      v-model="configuracao.msgCartaCorrecao" rows="5" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgRelDeclaracaoMensal">Mensagem Texto Declaração/Detalhamento DAM:</label>
                    <textarea id="msgRelDeclaracaoMensal" name="msgRelDeclaracaoMensal"
                      v-model="configuracao.msgRelDeclaracaoMensal" rows="5" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgImuneIssqn">Mensagem ISSQN Regime Imune:</label>
                    <textarea id="msgImuneIssqn" name="msgImuneIssqn" v-model="configuracao.msgImuneIssqn" rows="5" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgIsentoIssqn">Mensagem ISSQN Natureza Isenção:</label>
                    <textarea id="msgIsentoIssqn" name="msgIsentoIssqn" v-model="configuracao.msgIsentoIssqn" rows="5" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgMei">Mensagem ISSQN Regime MEI:</label>
                    <span class="p-fluid">
                      <textarea id="msgMei" name="msgMei" v-model="configuracao.msgMei" rows="5" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgOptanteSimples">Mensagem ISSQN Optantes Simples Nacional:</label>
                    <span class="p-fluid">
                      <textarea id="msgOptanteSimples" name="msgOptanteSimples" v-model="configuracao.msgOptanteSimples"
                        rows="5" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgAutenticidadeNfse">Mensagem Autenticidade Nfs-e:</label>
                    <span class="p-fluid">
                      <textarea id="msgAutenticidadeNfse" name="msgAutenticidadeNfse"
                        v-model="configuracao.msgAutenticidadeNfse" rows="5" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgDapsRecolhidoFora">Mensagem DAPS Recolhido Fora:</label>
                    <span class="p-fluid">
                      <textarea id="msgDapsRecolhidoFora" name="msgDapsRecolhidoFora"
                        v-model="configuracao.msgDapsRecolhidoFora" rows="5" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgDapsRecolhidoSede">Mensagem DAPS Recolhido Município:</label>
                    <span class="p-fluid">
                      <textarea id="msgDapsRecolhidoSede" name="msgDapsRecolhidoSede"
                        v-model="configuracao.msgDapsRecolhidoSede" rows="5" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgRetencaoMunicipio">Mensagem Retenção Município:</label>
                    <span class="p-fluid">
                      <textarea id="msgRetencaoMunicipio" name="msgRetencaoMunicipio"
                        v-model="configuracao.msgRetencaoMunicipio" rows="5" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgRetencaoForaMunicipio">Mensagem Retenção Fora do Município:</label>
                    <span class="p-fluid">
                      <textarea id="msgRetencaoForaMunicipio" name="msgRetencaoForaMunicipio"
                        v-model="configuracao.msgRetencaoForaMunicipio" rows="5" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgAutonomo">Mensagem Autônomo:</label>
                    <span class="p-fluid">
                      <textarea id="msgAutonomo" name="msgAutonomo" v-model="configuracao.msgAutonomo" rows="5" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgPagaIssNotaFiscal">Mensagem Pagamento ISSQN Nota Fiscal:</label>
                    <span class="p-fluid">
                      <textarea id="msgPagaIssNotaFiscal" name="msgPagaIssNotaFiscal"
                        v-model="configuracao.msgPagaIssNotaFiscal" rows="5" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgTermoCredenciamento">Mensagem Termo de Credenciamento:</label>
                    <span class="p-fluid">
                      <textarea id="msgTermoCredenciamento" name="msgTermoCredenciamento"
                        v-model="configuracao.msgTermoCredenciamento" rows="5" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgTermoCredenciamentoPessoaFisica">Mensagem Termo de Credenciamento Pessoa Física:</label>
                    <span class="p-fluid">
                      <textarea id="msgTermoCredenciamentoPessoaFisica" name="msgTermoCredenciamentoPessoaFisica"
                        v-model="configuracao.msgTermoCredenciamentoPessoaFisica" rows="5" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgTermoCancelamento">Mensagem Termo de Cancelamento:</label>
                    <span class="p-fluid">
                      <textarea id="msgTermoCancelamento" name="msgTermoCancelamento"
                        v-model="configuracao.msgTermoCancelamento" maxlength="255" rows="5" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgDecSimplificada">Mensagem Tela Declaração Simplificada/DAM Avulso:</label>
                    <span class="p-fluid">
                      <textarea id="msgDecSimplificada" name="msgDecSimplificada"
                        v-model="configuracao.msgDecSimplificada" rows="5" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgAvisoDebitoRdt">Mensagem de Aviso quando existir Débitos e utilziar o Fechamento por RDT após o login de acesso do Usuário:</label>
                    <span class="p-fluid">
                      <textarea id="msgAvisoDebitoRdt" name="msgAvisoDebitoRdt"
                        v-model="configuracao.msgAvisoDebitoRdt" rows="5" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgSublimiteNacional">Mensagem Sublimite Nacional Ultrapassado:</label>
                    <span class="p-fluid">
                      <textarea id="msgSublimiteNacional" name="msgSublimiteNacional" v-model="configuracao.msgSublimiteNacionalUltrapassado"
                        rows="5" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgBloqueioEmissaoNotaFiscal">Mensagem Bloqueio Emissão Nota Fiscal:</label>
                    <span class="p-fluid">
                      <textarea id="msgBloqueioEmissaoNotaFiscal" name="msgBloqueioEmissaoNotaFiscal" v-model="configuracao.msgBloqueioEmissaoNotaFiscal" 
                      rows="5" />
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="msgCalculoValorLiquido">Mensagem Cálculo Valor Líquido Nota Fiscal:</label>
                    <span class="p-fluid">
                      <textarea id="msgCalculoValorLiquido" name="msgCalculoValorLiquido" v-model="configuracao.msgCalculoValorLiquido"
                        rows="5" />
                    </span>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="Impostos Federais por Percentual">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-8 mb-2">
                    <label>Configure os valores abaixo e habilite esta opção para que na emissão de notas fiscais
                      eletrônicas, o usuário consiga atribuir os impostos federais com os percentuais definidos.</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-2 mb-2">
                    <label for="aliquotaInss">Alíquota Inss %:</label>
                    <span class="p-fluid">
                      <money id="aliquotaInss" name="aliquotaInss" v-model="configuracaoImpFederais.aliquotaInss"
                        v-bind="percent" class="p-inputtext input-right"></money>
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-2 mb-2">
                    <label for="aliquotaIr">Alíquota Ir %:</label>
                    <span class="p-fluid">
                      <money id="aliquotaIr" name="aliquotaIr" v-model="configuracaoImpFederais.aliquotaIr"
                        v-bind="percent" class="p-inputtext input-right"></money>
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-2 mb-2">
                    <label for="aliquotaCsll">Alíquota Csll %:</label>
                    <span class="p-fluid">
                      <money id="aliquotaCsll" name="aliquotaCsll" v-model="configuracaoImpFederais.aliquotaCsll"
                        v-bind="percent" class="p-inputtext input-right"></money>
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-2 mb-2">
                    <label for="aliquotaPis">Alíquota Pis %:</label>
                    <span class="p-fluid">
                      <money id="aliquotaPis" name="aliquotaPis" v-model="configuracaoImpFederais.aliquotaPis"
                        v-bind="percent" class="p-inputtext input-right"></money>
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-2 mb-2">
                    <label for="aliquotaCofins">Alíquota Cofins %:</label>
                    <span class="p-fluid">
                      <money id="aliquotaCofins" name="percentualCofins" v-model="configuracaoImpFederais.aliquotaCofins"
                        v-bind="percent" class="p-inputtext input-right"></money>
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4 mb-2">
                    <Button :label="!this.configuracaoImpFederais.id ? 'Habilitar' : 'Atualizar'"
                      :title="!this.configuracaoImpFederais.id ? 'Habilitar' : 'Atualizar'"
                      @click="salvarConfImpFederais()" class="p-button-primary mr-2 p-button-success" icon="pi pi-check"
                      :disabled="loading">
                    </Button>
                    <Button label="Desabilitar" title="Desabilitar" @click="deletarConfImpFederais()"
                      class="p-button-danger mr-2" icon="pi pi-times" :disabled="loading"
                      v-if="this.configuracaoImpFederais && this.configuracaoImpFederais.id">
                    </Button>
                  </div>
                </div>
              </div>
            </TabPanel>
          </TabView>
          <div class="botoes-avancar-voltar" style="margin-left: 30px;" v-if="!isBloqueado">
            <Button label="Gravar" title="Gravar" type="submit" class="p-button-primary mr-2 p-button-success"
              icon="pi pi-check" :disabled="loading">
            </Button>
          </DIV>
          <Dialog
            class="test-box"
            header="Configurações Bloqueio DAM Após o Vencimento"
            :visible.sync="showConfigFechamentoAutomatico"
            :contentStyle="{ overflow: 'visible' }"
            :modal="true"
            :closable="false"
          >
          <Panel header="Opção: Ambos">
             Dams/Declarações de ISS Normal e Substituição  (Não inclui DAPS apenas notas fiscais)
          </Panel><br/>
          <Panel header="Opção: Normal">
            Apenas Dams/Declarações de ISS Normal
          </Panel><br/>
          <Panel header="Opção: Substituição">
            Apenas Dams/Declarações de ISS de Substituição (Não inclui DAPS apenas notas fiscais)
          </Panel><br/>
          <Panel header="Opção: Resumo de Declaração Tributária (RDT)">
            Quando Configurado ira realizar o fechamento automatico da DAM após o vencimento, tanto de Dams Normais Quanto de Substituição (incluindo também as DAPS).
            <br/>No Dia 01 do mês posterior ao fechamento automático ira gerar o processo de notificação de RDT entrando os dams que não foram pagos.
          </Panel>
          <hr/>
          <template>
            <Button label="Fechar" title="Fechar" @click="showConfigFechamentoAutomatico = false" class="p-button-primary  mr-2 p-button-danger"
              icon="pi pi-times" :disabled="loading">
            </Button>
          </template>
        </Dialog>
          <Dialog
            class="test-box"
            header="Configurações Bloqueio DAM Após o Vencimento"
            :visible.sync="showConfigDamVenc"
            :contentStyle="{ overflow: 'visible' }"
            :modal="true"
            :closable="false"
          >
          <Panel header="Dias Configurados: -2">
            Não Bloqueado.
          </Panel>
          <br />
          <Panel header="Dias Configurados: 0">
            Os Dams Vencidos não poderão ser atualizados.
          </Panel>
          <br />
          <Panel header="Dias Configurados: >0">
            Os Dams só poderão ser atualizados se não estiverem vencidos conforme a quantidade de dias configurada.
          </Panel>
          <hr/>
          <template>
            <Button label="Fechar" title="Fechar" @click=closeTextDamCnfig() class="p-button-primary  mr-2 p-button-danger"
              icon="pi pi-times" :disabled="loading">
            </Button>
          </template>
        </Dialog>
        <Dialog
            class="test-box"
            header="Configurações Dias Cancelamento Nota Fiscal"
            :visible.sync="showConfigDiasCancNfse"
            :contentStyle="{ overflow: 'visible' }"
            :modal="true"
            :closable="false"
          >
          <Panel header="Dias Configurados: -1">
             O Prazo máximo para o cancelamento da Nota Fiscal será até o vencimento do ISS.
          </Panel>
          <br />
          <Panel header="Dias Configurados: >0">
            O Prazo máximo para o cancelamento da Nota Fiscal será de acordo com os dias configurados, partindo do Fato Gerador da Nota Fiscal.
          </Panel>
          <hr/>
          <template>
            <Button label="Fechar" title="Fechar" @click=closeTextCancNfsConfig() class="p-button-primary  mr-2 p-button-danger"
              icon="pi pi-times" :disabled="loading">
            </Button>
          </template>
        </Dialog>
        <Dialog
            class="test-box"
            header="Configurações Dias Cancelamento Nota Fiscal"
            :visible.sync="showConfigDiasSubsNfse"
            :contentStyle="{ overflow: 'visible' }"
            :modal="true"
            :closable="false"
          >
          <Panel header="Dias Configurados: -1">
             O Prazo máximo para a substituição da Nota Fiscal será até o período de competência de emissão da Nota Fiscal que será substituída.
          </Panel>
          <br />
          <Panel header="Dias Configurados: >0">
            O Prazo máximo para a substituição da Nota Fiscal será de acordo com os dias configurados, partindo do Fato Gerador da Nota Fiscal.
          </Panel>
          <hr/>
          <template>
            <Button label="Fechar" title="Fechar" @click=closeTextSubsNfsConfig() class="p-button-primary  mr-2 p-button-danger"
              icon="pi pi-times" :disabled="loading">
            </Button>
          </template>
        </Dialog>
        <Dialog
          class="test-box"
          header="Configurações Dias Cancelamento Nota Fiscal (Optante Simples Nacional)"
          :visible.sync="showConfigDiasCancNfseOptante"
          :contentStyle="{ overflow: 'visible' }"
          :modal="true"
          :closable="false"
        >
        <Panel header="Dias Configurados: -1">
          O Prazo máximo para o cancelamento da Nota Fiscal será até o vencimento do ISS.
        </Panel>
        <br />
        <Panel header="Dias Configurados: > 0">
          O Prazo máximo para o cancelamento da Nota Fiscal será de acordo com os dias configurados, partindo do Fato Gerador da Nota Fiscal.
        </Panel>
        <Panel header="Dias Configurados: Vazio">
          Caso não informado valor na configuração deste campo será utilizado o padrão de dias para o cancelamento da Nota Fiscal.
        </Panel>
        <hr/>
        <template>
          <Button label="Fechar" title="Fechar" @click="showConfigDiasCancNfseOptante = false" class="p-button-primary  mr-2 p-button-danger"
            icon="pi pi-times" :disabled="loading">
          </Button>
        </template>
      </Dialog>
        <Dialog
            class="test-box"
            header="Mensagem Padrão Termo de Cancelamento Nota Fiscal"
            :visible.sync="showMsgTermoCancNfse"
            :contentStyle="{ overflow: 'visible' }"
            :modal="true"
            :closable="false"
          >
          <Panel header="Mensagem Padrão">
            Esta Mensagem será exibida por padrão caso o campo de Texto Adicional abaixo não esteja preenchido.
          </Panel>
          <br />
          <Panel header="Configuração de Prazos para Cancelamento de Notas Fiscais">
            No lugar de "(Prazo de dias conforme o vencimento da Nota Fiscal)" seram exibidos os dias Configurados para Prazo de Vencimento e os dias corridos referente ao período permitido para Cancelamento da Nota Fiscal.
          </Panel>
          <hr/>
          <template>
            <Button label="Fechar" title="Fechar" @click=closeTextTermoCancNfs() class="p-button-primary  mr-2 p-button-danger"
              icon="pi pi-times" :disabled="loading">
            </Button>
          </template>
        </Dialog>
        <Dialog
            class="test-box"
            header="Mensagem Adicional Termo de Cancelamento Nota Fiscal"
            :visible.sync="showMsgAdicTermoCancNfse"
            :contentStyle="{ overflow: 'visible' }"
            :modal="true"
            :closable="false"
          >
          <Panel header="Mensagem Adicional">
            Esta mensagem adicional será exibida juntamente com a mensagem padrão no Termo de Cancelamento da Nota Fiscal.
          </Panel>
          <hr/>
          <template>
            <Button label="Fechar" title="Fechar" @click=closeTextAdicTermoCancNfs() class="p-button-primary  mr-2 p-button-danger"
              icon="pi pi-times" :disabled="loading">
            </Button>
          </template>
        </Dialog>
        <Dialog
            class="test-box"
            header="Dados de Contato Cliente"
            :visible.sync="showMsgContatoLogin"
            :contentStyle="{ overflow: 'visible' }"
            :modal="true"
            :closable="false"
          >
          <Panel header="Dados Contato Login">
            Os dados preenchidos neste campo serão exibidos ao clicar na opção "Consultar Dados Municipais de Contato" na tela de Login do sistema NFS-E.
          </Panel>
          <hr/>
          <template>
            <Button label="Fechar" title="Fechar" @click=closeMsgContatoLogin() class="p-button-primary  mr-2 p-button-danger"
              icon="pi pi-times" :disabled="loading">
            </Button>
          </template>
        </Dialog>
          <Dialog
            class="test-box"
            header="Configurações Impressão Nota Fiscal Avulsa Sem Pagamento"
            :visible.sync="showConfigVisuDam"
            :contentStyle="{ overflow: 'visible' }"
            :modal="true"
            :closable="false"
            :style="{maxWidth: '1200px'}"
          >
          <Panel header="Opção: Sim">
            O sistema permite que o usuário imprima a Nota Fiscal Avulsa mesmo que a mesma não esteja paga.
          </Panel>
          <br />
          <Panel header="Opção: Não">
            Mantém o funcionamento padrão do sistema e não permite que a opção de Imprimir a Nota Fiscal Avulsa seja exibida.
          </Panel>
          <br />
          <Panel header="Opção: Exibir Sem Valor Fiscal">
            O sistema permite que o usário imprima a Nota Fiscal Avulsa mesmo sem estar paga, porém, com algumas validações para exibição da Tarja "Sem Valor Fiscal" no Relatório:<br/>
            1º - Caso o prestador seja Devedor Contumaz e a nota não esteja paga. <br/>
            2º - Caso a situação da Nota Fiscal Avulsa for diferente de Paga, a situação for Ativa e a Nota Fiscal incidir ISS.<br/><br/>

            Se não forem validadas uma das duas opções acima, a Nota Fiscal Avulsa será impressa sem a Tarja.
          </Panel>
          <hr/>
          <template>
            <Button label="Fechar" title="Fechar" @click="showConfigVisuDam = false" class="p-button-primary  mr-2 p-button-danger"
              icon="pi pi-times" :disabled="loading">
            </Button>
          </template>
        </Dialog>
        <Dialog
            class="test-box"
            header="Bloquear emissão nfse tomador de serviços inativo?"
            :visible.sync="showConfigBloquearTomador"
            :contentStyle="{ overflow: 'visible' }"
            :modal="true"
            :closable="false"
            :style="{maxWidth: '1200px'}"
          >
          <Panel header="Informação: ">
            Considerar inativo ou baixado as empresas/tomadores que estão ligadas a situação no GPI referentes a tabela: el_trb_dic.dic_trb_situacao, 
            o campo id_bol_ativo_nfse ira indicar as situações que podem ser ativas ou não no nfse.
          </Panel>
          <Panel header="Opção: Sim (Não permite adicionar empresa Inativa ou Baixada)">
            O sistema não ira listar os tomadores de serviços de prestadores relacionados a um tipo de cadastrado inativo ou baixado
            e ira bloquear a emissão de nota se o cpf/cnpj for de uma empresa nessas condições nestes casos quando ocorer por exemplo
            uma mudança de prestador da sede para outro municipio sera obrigatório que o municipio lance uma inscrição no eventual manualmente
            pelo GPI para que libere o prestador para cadastro deste tomador.
          </Panel>
          <br />
          <Panel header="Opção: Sim (Permite adicionar uma nova inscrição empresa esta Inativa ou Baixada)">
            O sistema não ira listar os tomadores de serviços de prestadores relacionados a um tipo de cadastrado inativo ou baixado,
            porém permitirá que o prestador lance um novo cadastro de tomador para o cpf/cnpj não relacionando a inscrição do município
            inativa ou baixada.
          </Panel>
          <br />
          <Panel header="Opção: Não">
            O sistema não controla a lista de tomadores de cada prestador quanto a seu status se a empresa estiver relacionada 
            a um tipo de cadastrado que possa vir a ser inativada ou baixada o sistema permitira que o usuário realize a emissão da nota.
          </Panel>
          <hr/>
          <template>
            <Button label="Fechar" title="Fechar" @click="showConfigBloquearTomador = false" class="p-button-primary  mr-2 p-button-danger"
              icon="pi pi-times" :disabled="loading">
            </Button>
          </template>
        </Dialog>
        <Dialog
            class="test-box"
            header="Configurações Dias Cancelamento Nota Fiscal"
            :visible.sync="showConfigAlqSubNfse"
            :contentStyle="{ overflow: 'visible' }"
            :modal="true"
            :closable="false"
          >
          <Panel header="Sim">
             Quando a empresa estiver em sublimite e as notas possuirem alíquota 0, serão alteradas para alíquota do serviço no ato da declaração.
          </Panel>
          <br />
          <Panel header="Não">
              O sistema irá respeitar a configuração atual das alíquotas.
          </Panel>
          <hr/>
          <Panel header="Total">
              Quando a empresa estiver em sublimite, todas as notas serão alteradas para alíquota do serviço no ato da declaração, independente da alíquota original.
          </Panel>
          <hr />
          <template>
            <Button label="Fechar" title="Fechar" @click=closeTextConfigAlqSubNfse() class="p-button-primary  mr-2 p-button-danger"
              icon="pi pi-times" :disabled="loading">
            </Button>
          </template>
        </Dialog>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { maska } from 'maska'
import money from "../conf/config.money";
import percent from "../conf/config.percent";
import LoginService from "../services/acesso/login.service";
import ConfiguracaoService from "../services/nfse/configuracao.service";
import Configuracao from "../models/nfse/Configuracao";
import ConfiguracaoImpFederais from "../models/nfse/ConfiguracaoImpFederais";
import moment from "moment";
import dateUtil from "../Utils/util"

export default {
  directives: { maska },
  name: "configuracao",
  data() {
    return {
      money: money,
      moment: moment,
      percent: percent,
      currentUser: null,
      loading: false,
      admin: 'N',
      camposAtivos: 'S',
      configuracao: new Configuracao(),
      configuracaoImpFederais: new ConfiguracaoImpFederais(),
      selectedTomadorNaoInformado: null,
      selectedFechamentoAutomatico: 'N',
      selectedAutonomoAliqZero: null,
      selectedValidaNovosImpostosNacionais: null,
      selectedSimplesAliqZero: null,
      selectedSublimiteAlterarAliquota: null,
      selectedAtualizaEnderecoPessoa: null,
      selectedBloqTomadorInativo: null,
      selectedRetTomadorEventual: null,
      selectedCartaCorrecao: null,
      selectedExibirCampoObservacao: null,
      selectedAliquotaSimplesRbt12: null,
      selectedRetencaoPessoaFisica: null,
      selectedGeracaoDamAutomatica: null,
      selectedNtAvulsaSemPgto: null,
      selectedDesabCredencAvulsa: null,
      selectedCalculoImpostosFederais: null,
      selectedDesabTomadorDiferente: null,
      selectedDeclaracaoAnalise: null,
      selectedRecusaDeclaracao: null,
      selectedAceiteTomador: null,
      selectedDetalhamentoDam: null,
      selectInscricaoCredenAutomatica: null,
      selectIdBolSubsTributarioGpi: null,
      selectedDesabDamSimplificada: null,
      selectedAnaliseCredenFora: null,
      selectedRegistraCredEventual: null,
      selectedManifestacao: null,
      selectedTipoPessoa: null,
      selectedIntermediario: null,
      selectedAceiteCancelamento: null,
      selectIdBolEditarEmailUsuarioRes: null,
      selectIdBolValidarIdRps: null,
      selectIdBolProducaoRestrita: null,
      selectIdBolHabilitarDpsProducao: null,
      selectIdBolCredenAutoMunic: null,
      selectedIdBolCompensaIssDaps: null,
      selectedCancNfseDataEmissao: null,
      selectedIdBolRetDecFechaAuto: null,
      selectedIdBolValidaValorNotaSubs: null,
      opcoes: [{ name: "Sim", key: "S" }, { name: "Não", key: "N" }],
      opcoesBloquearTomadorInativo: [{ name: "Sim (Não permite adicionar empresa Inativa ou Baixada)", key: "S" }, { name: "Sim (Permite adicionar uma nova inscrição empresa esta Inativa ou Baixada)", key: "R" }, { name: "Não", key: "N" }],
      opcoesRbt12: [{ name: "Sim", key: "S" }, { name: "Sim (Aliquota aberta para edição)", key: "A" },  { name: "Não", key: "N" }],
      opcoesCarta: [{ name: "Aceite Automático", key: "S" }, { name: "Deferimento pelo GPI", key: "N" }, { name: "Desativado", key: "D" }],
      opcoesGeracaoAutomatica: [{ name: "Ambos (Normal, Substituição)", key: "A" }, { name: "Normal", key: "N" }, { name: "Substituição", key: "S" }, { name: "Resumo de Declaração Tributária (RDT)", key: "R" }],
      opcoesTipoPessoa: [{ name: "Ambos", key: "A" }, { name: "Pessoa Física", key: "F" }, { name: "Pessoa Jurídica", key: "J" }],
      opcoesNtAvulsaSemPgto: [{name: "Sim", key: "S"}, {name: "Não", key: "N"}, {name: "Exibir Sem Valor Fiscal", key: "E"}],
      opcoesAlterarAlqNotas: [{name: "Sim", key: "S"}, {name: "Não", key: "N"}, {name: "Total", key: "T"}],
      selectedVersaoDanfseNacional: null,
      opcoesVersaoNacional: [{ name: "v1.0", key: "v1.0" }, { name: "v2.0", key: "v2.0" }],
      tooltipText: "Ver Informações",
      showConfigDamVenc: false,
      showConfigFechamentoAutomatico: false,
      showConfigDiasCancNfse: false,
      showConfigDiasCancNfseOptante: false,
      showMsgTermoCancNfse: false,
      showMsgAdicTermoCancNfse: false,
      msgTermoCancNfsPadrao: "O período máximo para cancelamento automático foi ultrapassado (Prazo de dias conforme o vencimento da Nota Fiscal). Caso realmente deseje cancelar esta nota, informe o motivo e a nota fiscal substituta (caso houver) e clique no botão abaixo para emissão do Termo de Pedido de Cancelamento de NFS-e.",
      showMsgContatoLogin: false,
      showConfigVisuDam: false,
      showConfigBloquearTomador: false,
      showConfigDiasSubsNfse: false,
      showConfigAlqSubNfse: false
    };
  },
  created() {
    this.currentUser = LoginService.currentUserValue;
    this.admin = (this.$route.query.admin != null && this.$route.query.admin != '' ? this.$route.query.admin : 'N');
    this.camposAtivos = this.admin; //variavel auxiliar caso precise desabilitar campos para edição, colocar a logica aqui
    console.log(this.currentUser.contribuinte.idContribuinte);

    setTimeout(async () => {
      await ConfiguracaoService.get(this.currentUser.usuario.idCliente).then(
        response => {
          this.configuracao = response.data;
          
          this.selectedTomadorNaoInformado = this.opcoes.filter(
            local => local.key == this.configuracao.idBolTomadorNaoInformado
          )[0];
          this.selectedFechamentoAutomatico = this.opcoes.filter(
            local => local.key == this.configuracao.idBolFechamentoAutomatico
          )[0];

          this.selectedAutonomoAliqZero = this.opcoes.filter(
            local => local.key == this.configuracao.idBolAutonomoAliqZero
          )[0];
          this.selectedValidaNovosImpostosNacionais = this.opcoes.filter(
            local => local.key == this.configuracao.idBolValidaNovosImpostosNacionais
          )[0];
          this.selectedVersaoDanfseNacional = this.opcoesVersaoNacional.filter(
            local => local.key == (this.configuracao.versaoImpressaoDanfseNacional || 'v2.0')
          )[0];
          this.selectedSimplesAliqZero = this.opcoes.filter(
            local => local.key == this.configuracao.idBolSimplesNacAliqZero
          )[0];
          this.selectedSublimiteAlterarAliquota = this.opcoesAlterarAlqNotas.filter(
            local => local.key == this.configuracao.idBolSublimiteAlterarAliquota
          )[0];
          this.selectedAtualizaEnderecoPessoa = this.opcoes.filter(
            local => local.key == this.configuracao.idBolAtualizaEnderecoPessoa
          )[0];
          this.selectedBloqTomadorInativo = this.opcoesBloquearTomadorInativo.filter(
            local => local.key == this.configuracao.idBolBloquearTomadorInativo
          )[0];
          this.selectedRetTomadorEventual = this.opcoes.filter(
            local => local.key == this.configuracao.idBolRetencaoTomadorEventual
          )[0];
          this.selectedRetencaoPessoaFisica = this.opcoes.filter(
            local =>
              local.key == this.configuracao.idBolRetencaoFontePessoaFisica
          )[0];
          this.selectedGeracaoDamAutomatica = this.opcoesGeracaoAutomatica.filter(
            local =>
              local.key == this.configuracao.idBolTipoDamAutomatico
          )[0];
          this.selectedCartaCorrecao = this.opcoesCarta.filter(
            local =>
              local.key == this.configuracao.idBolCartaCorrecaoAutomatica
          )[0];
          this.selectedExibirCampoObservacao = this.opcoes.filter(
            local =>
              local.key == this.configuracao.idBolObservacaoNfse
          )[0];
          this.selectedAliquotaSimplesRbt12 = this.opcoesRbt12.filter(
            local =>
              local.key == this.configuracao.idBolAliquotaSimplesRbt12
          )[0];
          this.selectedNtAvulsaSemPgto = this.opcoesNtAvulsaSemPgto.filter(
            local =>
              local.key == this.configuracao.idBolNotaAvulsaSemPgto
          )[0];
          this.selectedDesabCredencAvulsa = this.opcoes.filter(
            local =>
              local.key == this.configuracao.idBolDesabilitarCredencAvulsa
          )[0];
          this.selectedCalculoImpostosFederais = this.opcoes.filter(
            local =>
              local.key == this.configuracao.idBolCalculoImpostosFederais
          )[0];
          this.selectedDesabTomadorDiferente = this.opcoes.filter(
            local =>
              local.key == this.configuracao.idBolSelTomadorDiferente
          )[0];
          this.selectedDeclaracaoAnalise = this.opcoes.filter(
            local =>
              local.key == this.configuracao.idBolDecRetifAnalise
          )[0];
          
          this.selectedRecusaDeclaracao = this.opcoes.filter(
            local =>
              local.key == this.configuracao.idBolRecusaDeclaracao
          )[0];
          this.selectedAceiteTomador = this.opcoes.filter(
            local =>
              local.key == this.configuracao.idBolAceiteTomador
          )[0];
          this.selectedDetalhamentoDam = this.opcoes.filter(
            local =>
              local.key == this.configuracao.idBolExibirDetalhamentoDam
          )[0];
          this.selectedDesabDamSimplificada = this.opcoes.filter(
            local =>
              local.key == this.configuracao.idBolDamDecSimplificada
          )[0];
          this.selectedAnaliseCredenFora = this.opcoes.filter(
            local =>
              local.key == this.configuracao.idBolAnaliseCreden
          )[0];
          this.selectedRegistraCredEventual = this.opcoes.filter(
            local =>
              local.key == this.configuracao.idBolRegistrarCredEventual
          )[0];
          this.selectedIntermediario = this.opcoes.filter(
            local =>
              local.key == this.configuracao.idBolIntermediario
          )[0];
          this.selectedManifestacao = this.opcoes.filter(
            local =>
              local.key == this.configuracao.idBolManifestacao
          )[0];
          this.selectedTipoPessoa = this.opcoesTipoPessoa.filter(
            local =>
              local.key == this.configuracao.nfManifestacaoTipoPessoa
          )[0];
          this.selectedAceiteCancelamento = this.opcoes.filter(
            local =>
              local.key == this.configuracao.nfCancelamentoCienciaTomador
          )[0];
          this.selectInscricaoCredenAutomatica = this.opcoes.filter(
            local =>
              local.key == this.configuracao.idBolInscricaoCredenAutomatica
          )[0];
          this.selectIdBolSubsTributarioGpi = this.opcoes.filter(
            local =>
              local.key == this.configuracao.idBolSubsTributarioGpi
          )[0];
          this.selectIdBolEditarEmailUsuarioRes = this.opcoes.filter(
            local =>
              local.key == this.configuracao.idBolEditarEmailUsuarioRes
          )[0];
          this.selectIdBolValidarIdRps = this.opcoes.filter(
            local =>
              local.key == this.configuracao.idBolValidarIdRps
          )[0];
          this.selectIdBolProducaoRestrita = this.opcoes.filter(
            local =>
              local.key == this.configuracao.idBolProducaoRestrita
          )[0];
          this.selectIdBolHabilitarDpsProducao = this.opcoes.filter(
            local =>
              local.key == this.configuracao.idBolHabilitarDpsProducao
          )[0];
          this.selectIdBolCredenAutoMunic = this.opcoes.filter(
            local =>
              local.key == this.configuracao.idBolCredenAutoMunic
          )[0];
          this.selectedIdBolCompensaIssDaps = this.opcoes.filter(
            local =>
              local.key == this.configuracao.idBolCompensaIssDaps
          )[0];
          this.selectedIdBolRetDecFechaAuto = this.opcoes.filter(
            local =>
              local.key == this.configuracao.idBolRetDecFechaAuto
          )[0];
          this.selectedIdBolValidaValorNotaSubs = this.opcoes.filter(
            local =>
              local.key == this.configuracao.idBolValidaValorNotaSubs
          )[0];
          this.selectedCancNfseDataEmissao = this.opcoes.filter(
            local =>
              local.key == this.configuracao.cancNotaPrazoEmissao
          )[0];
          
          this.configuracao.dataBloqueioEmissaoMei = dateUtil.stringToDate(this.configuracao.dataBloqueioEmissaoMei);
					this.configuracao.dataBloqueioEmissaoNfse = dateUtil.stringToDate(this.configuracao.dataBloqueioEmissaoNfse);
          
          setTimeout(async () => {
            await ConfiguracaoService.getConfImpFederais(this.currentUser.usuario.idCliente).then(
              response => {
                if (response.data) {
                  this.configuracaoImpFederais = response.data;
                } else {
                  this.configuracaoImpFederais = new ConfiguracaoImpFederais();
                }

              },
              error => {
                let errorMessage = "Houve um problema ao buscar a configuracao imp federais!";
                if (error.response) {
                  errorMessage = error.response.data;
                }
                this.$toast.add({
                  severity: "error",
                  summary: errorMessage
                });
              }
            );
          }, 250);

        },
        error => {
          let errorMessage = "Houve um problema ao buscar a configuracao!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
    }, 250);
  },
  mounted() {
    if (!this.currentUser.usuario.idBolAdmin) {
      this.$toast.add({
        severity: "error",
        summary: "Você não tem permissão de acesso a estas configurações!"
      });
      this.$router.push(this.currentUser.homePage);
    }
  },
  methods: {
    onSubmit() {
      this.loading = true;

      this.salvar();

      this.loading = false;
    },
    salvar() {
      this.configuracao.idBolTomadorNaoInformado = this
        .selectedTomadorNaoInformado
        ? this.selectedTomadorNaoInformado.key
        : null;
      this.configuracao.idBolFechamentoAutomatico = this
        .selectedFechamentoAutomatico
        ? this.selectedFechamentoAutomatico.key
        : 'N';
      this.configuracao.idBolAutonomoAliqZero = this.selectedAutonomoAliqZero
        ? this.selectedAutonomoAliqZero.key
        : null;
      this.configuracao.idBolValidaNovosImpostosNacionais = this.selectedValidaNovosImpostosNacionais
        ? this.selectedValidaNovosImpostosNacionais.key
        : null;
      this.configuracao.versaoImpressaoDanfseNacional = this.selectedVersaoDanfseNacional
        ? this.selectedVersaoDanfseNacional.key
        : 'v2.0';
      this.configuracao.idBolSimplesNacAliqZero = this.selectedSimplesAliqZero
        ? this.selectedSimplesAliqZero.key
        : null;
      this.configuracao.idBolSublimiteAlterarAliquota = this.selectedSublimiteAlterarAliquota
        ? this.selectedSublimiteAlterarAliquota.key
        : null;
      this.configuracao.idBolAtualizaEnderecoPessoa = this.selectedAtualizaEnderecoPessoa
        ? this.selectedAtualizaEnderecoPessoa.key
        : null;
      this.configuracao.idBolBloquearTomadorInativo = this.selectedBloqTomadorInativo
        ? this.selectedBloqTomadorInativo.key
        : null;
      this.configuracao.idBolRetencaoTomadorEventual = this.selectedRetTomadorEventual
        ? this.selectedRetTomadorEventual.key
        : null;
      this.configuracao.idBolRetencaoFontePessoaFisica = this
        .selectedRetencaoPessoaFisica
        ? this.selectedRetencaoPessoaFisica.key
        : null;
      this.configuracao.idBolTipoDamAutomatico = this
        .selectedGeracaoDamAutomatica
        ? this.selectedGeracaoDamAutomatica.key
        : null;
      this.configuracao.idBolCartaCorrecaoAutomatica = this.selectedCartaCorrecao
        ? this.selectedCartaCorrecao.key
        : null;
      this.configuracao.idBolObservacaoNfse = this.selectedExibirCampoObservacao
        ? this.selectedExibirCampoObservacao.key
        : null;
        this.configuracao.idBolAliquotaSimplesRbt12 = this.selectedAliquotaSimplesRbt12
        ? this.selectedAliquotaSimplesRbt12.key
        : null;
      this.configuracao.idBolNotaAvulsaSemPgto = this.selectedNtAvulsaSemPgto
        ? this.selectedNtAvulsaSemPgto.key
        : null;
      this.configuracao.idBolDesabilitarCredencAvulsa = this.selectedDesabCredencAvulsa
        ? this.selectedDesabCredencAvulsa.key
        : null;
      this.configuracao.idBolCalculoImpostosFederais = this.selectedCalculoImpostosFederais
        ? this.selectedCalculoImpostosFederais.key
        : null;
      this.configuracao.idBolSelTomadorDiferente = this.selectedDesabTomadorDiferente
        ? this.selectedDesabTomadorDiferente.key
        : null;
      this.configuracao.idBolDecRetifAnalise = this.selectedDeclaracaoAnalise
        ? this.selectedDeclaracaoAnalise.key
        : null;
      this.configuracao.idBolRecusaDeclaracao = this.selectedRecusaDeclaracao
        ? this.selectedRecusaDeclaracao.key
        : null;
      this.configuracao.idBolAceiteTomador = this.selectedAceiteTomador
        ? this.selectedAceiteTomador.key
        : null;
      this.configuracao.idBolExibirDetalhamentoDam = this.selectedDetalhamentoDam
        ? this.selectedDetalhamentoDam.key
        : null;
      this.configuracao.idBolDamDecSimplificada = this.selectedDesabDamSimplificada
        ? this.selectedDesabDamSimplificada.key
        : null;
      this.configuracao.idBolAnaliseCreden = this.selectedAnaliseCredenFora
        ? this.selectedAnaliseCredenFora.key
        : null;
      this.configuracao.idBolRegistrarCredEventual = this.selectedRegistraCredEventual
        ? this.selectedRegistraCredEventual.key
        : null;
      this.configuracao.idBolIntermediario = this.selectedIntermediario
        ? this.selectedIntermediario.key
        : null;
      this.configuracao.idBolManifestacao = this.selectedManifestacao
        ? this.selectedManifestacao.key
        : null;
      this.configuracao.nfManifestacaoTipoPessoa = this
        .selectedTipoPessoa
        ? this.selectedTipoPessoa.key
        : 'A';
        this.configuracao.nfCancelamentoCienciaTomador = this.selectedAceiteCancelamento
        ? this.selectedAceiteCancelamento.key
        : null;
      this.configuracao.idBolInscricaoCredenAutomatica = this.selectInscricaoCredenAutomatica
        ? this.selectInscricaoCredenAutomatica.key
        : null;
      this.configuracao.idBolSubsTributarioGpi = this.selectIdBolSubsTributarioGpi
        ? this.selectIdBolSubsTributarioGpi.key
        : null;
      this.configuracao.idBolEditarEmailUsuarioRes = this.selectIdBolEditarEmailUsuarioRes
        ? this.selectIdBolEditarEmailUsuarioRes.key
        : null;
      this.configuracao.idBolValidarIdRps = this.selectIdBolValidarIdRps
        ? this.selectIdBolValidarIdRps.key
        : null;
      this.configuracao.idBolProducaoRestrita = this.selectIdBolProducaoRestrita
        ? this.selectIdBolProducaoRestrita.key
        : null;
      this.configuracao.idBolHabilitarDpsProducao = this.selectIdBolHabilitarDpsProducao
        ? this.selectIdBolHabilitarDpsProducao.key
        : null;
      this.configuracao.idBolCredenAutoMunic = this.selectIdBolCredenAutoMunic
        ? this.selectIdBolCredenAutoMunic.key
        : null;
      this.configuracao.idBolCompensaIssDaps = this.selectedIdBolCompensaIssDaps
        ? this.selectedIdBolCompensaIssDaps.key
        : null;
      this.configuracao.idBolRetDecFechaAuto = this.selectedIdBolRetDecFechaAuto
        ? this.selectedIdBolRetDecFechaAuto.key
        : null;
      this.configuracao.idBolValidaValorNotaSubs = this.selectedIdBolValidaValorNotaSubs
        ? this.selectedIdBolValidaValorNotaSubs.key
        : null;
      this.configuracao.cancNotaPrazoEmissao = this.selectedCancNfseDataEmissao
        ? this.selectedCancNfseDataEmissao.key
        : null;
        
        
      ConfiguracaoService.save(this.configuracao).then(
        data => {
          this.configuracao = data.data;

          this.configuracao.dataBloqueioEmissaoMei = dateUtil.stringToDate(this.configuracao.dataBloqueioEmissaoMei);
					this.configuracao.dataBloqueioEmissaoNfse = dateUtil.stringToDate(this.configuracao.dataBloqueioEmissaoNfse);

          this.$toast.add({
            severity: "success",
            summary: "Configuracão salva com sucesso"
          });
        },
        error => {
          let errorMessage = "Houve um problema ao salvar a configuracao!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
    },
    salvarConfImpFederais() {
      if (!this.configuracaoImpFederais.idCliente) {
        this.configuracaoImpFederais.idCliente = this.currentUser.usuario.idCliente;
      }
      ConfiguracaoService.saveConfImpFederais(this.configuracaoImpFederais).then(
        response => {
          console.log(response);
          this.configuracaoImpFederais = response.data;
          this.$toast.add({
            severity: "success",
            summary: "Configuracão habilitada com sucesso"
          });
        },
        error => {
          let errorMessage = "Houve um problema ao salvar a configuracao imp federais!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
    },
    deletarConfImpFederais() {
      ConfiguracaoService.deleteConfImpFederais(this.configuracaoImpFederais.id).then(
        data => {
          console.log(data);
          this.configuracaoImpFederais = new ConfiguracaoImpFederais();
          this.$toast.add({
            severity: "success",
            summary: "Configuracão desabilitada com sucesso"
          });
        },
        error => {
          let errorMessage = "Houve um problema ao desabilitar a configuracao imp federais!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
    },
    openTextDamConfig(){
      this.showConfigDamVenc = true;
    },
    openTextFechamentoAutomatico(){
      this.showConfigFechamentoAutomatico = true;
    },
    closeTextDamCnfig(){
      this.showConfigDamVenc = false;
    },
    openTextCancNfsConfig(){
      this.showConfigDiasCancNfse = true;
    },
    closeTextCancNfsConfig(){
      this.showConfigDiasCancNfse = false;
    },
    openTextSubsNfsConfig(){
      this.showConfigDiasSubsNfse = true;
    },
    closeTextSubsNfsConfig(){
      this.showConfigDiasSubsNfse = false;
    },
    openTextCancNfsOptanteConfig(){
      this.showConfigDiasCancNfseOptante = true;
    },
    openTextTermoCancNfs(){
      this.showMsgTermoCancNfse = true;
    },
    closeTextTermoCancNfs(){
      this.showMsgTermoCancNfse = false;
    },
    openTextAdicTermoCancNfs(){
      this.showMsgAdicTermoCancNfse = true;
    },
    closeTextAdicTermoCancNfs(){
      this.showMsgAdicTermoCancNfse = false;
    },
    openMsgContatoLogin(){
      this.showMsgContatoLogin = true;
    },
    closeMsgContatoLogin(){
      this.showMsgContatoLogin = false;
    },
    openTextVisuDam(){
      this.showConfigVisuDam = true;
    },
    openTextBloquearTomador(){
      this.showConfigBloquearTomador = true;
    },
    closeTextVisuDam(){
      this.showConfigVisuDam = false;
    },
    closeTextBloquearTomador(){
      this.showConfigBloquearTomador = false;
    },
    openTextConfigAlqSubNfse(){
      this.showConfigAlqSubNfse = true;
    },
    closeTextConfigAlqSubNfse(){
      this.showConfigAlqSubNfse = false;
    },
    verificarLimpeza() {
      if (this.configuracao.dataBloqueioEmissaoNfse) {
        this.configuracao.dataBloqueioEmissaoNfse = null
      }
    }
  },
  computed: {
    isBloqueado() {
      return this.currentUser && this.currentUser.idBolBloquearSistema && this.currentUser.idBolBloquearSistema === 'S';
    }
  }
};
</script>

<style src="../assets/css/configuracao.css"></style>